var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotConfident(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "8em",
    width: "8em",
    viewBox: "0 0 72 72",
    enableBackground: "new 0 0 72 72",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "strokeElem",
    fill: "none",
    stroke: "#00b5ed",
    strokeWidth: 1,
    strokeMiterlimit: 10,
    cx: 36,
    cy: 36,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "filled",
    fill: "#00b5ed",
    d: "M30.3,30.9c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3C29,27.9,30.3,29.3,30.3,30.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "filled",
    fill: "#00b5ed",
    d: "M48.3,30.9c0,1.7-1.3,3-3,3s-3-1.3-3-3c0-1.7,1.3-3,3-3S48.3,29.3,48.3,30.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    fill: "none",
    stroke: "#00b5ed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M27,44.1c1.9-1.5,5.8-2.5,10-2.4c3.8,0.1,7.3,1,9,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    fill: "none",
    stroke: "#00b5ed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M22,27c1.2-2.4,3-5,9-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "strokeElem",
    fill: "none",
    stroke: "#00b5ed",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M51,27c-1.2-2.4-3-5-9-4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotConfident);
export default __webpack_public_path__ + "static/media/not-confident.9a63259b.svg";
export { ForwardRef as ReactComponent };